/**
 * highlight(text, query)
 *
 * Entoure chaque occurrence de `query` dans `text` avec un tag <mark>.
 * Retourne du HTML brut (à utiliser avec v-html).
 *
 * - Insensible à la casse
 * - Protège les caractères spéciaux regex dans la requête
 * - Retourne le texte original si query est vide
 */
export function highlight(text: string | null | undefined, query: string): string {
  if (!text) return ''
  const q = query.trim()
  if (!q) return escapeHtml(text)

  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`(${escaped})`, 'gi')
  return escapeHtml(text).replace(regex, '<mark class="bg-warning/40 text-warning-content rounded px-0.5">$1</mark>')
}

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
